import {
  Avatar,
  AvatarFallback,
  AvatarImage,
  Badge,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@getgreenline/blaze-ui";
import type { BrandUserListItem } from "@/services/staff-brand-users.service";
import { getInitials } from "@/utils/strings";

export function UsersBrandsTable({ users }: { users: BrandUserListItem[] }) {
  return (
    <div className="tw:overflow-x-auto tw:rounded-lg tw:border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>User</TableHead>
            <TableHead>Brands</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {users.map((user) => (
            <TableRow key={user.email}>
              <TableCell>
                <div className="tw:flex tw:min-w-64 tw:items-center tw:gap-3">
                  <Avatar className="tw:size-9">
                    <AvatarFallback>{getInitials(user.email)}</AvatarFallback>
                  </Avatar>
                  <div className="tw:flex tw:flex-wrap tw:items-center tw:gap-2">
                    <span className="tw:font-medium">{user.email}</span>
                    {user.isOwner ? (
                      <Badge variant="secondary">Owner</Badge>
                    ) : null}
                  </div>
                </div>
              </TableCell>
              <TableCell>
                <div
                  className="tw:flex tw:flex-wrap tw:gap-2"
                  aria-label={`${user.brands.length} assigned ${user.brands.length === 1 ? "brand" : "brands"}`}
                >
                  {user.brands.map((brand) => (
                    <Badge
                      key={brand.id}
                      variant="outline"
                      className="tw:gap-1.5 tw:py-1 tw:pr-2"
                    >
                      <Avatar className="tw:size-5">
                        {brand.avatarImageUrl ? (
                          <AvatarImage src={brand.avatarImageUrl} alt="" />
                        ) : null}
                        <AvatarFallback className="tw:text-[9px]">
                          {getInitials(brand.name)}
                        </AvatarFallback>
                      </Avatar>
                      {brand.name}
                    </Badge>
                  ))}
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
